export type ApplicationField = {
	label: string
	value: any
	version: string[]
}

const detailGroups = [
	{
		title: 'Application Details',
		labels: [
			'Application Name',
			'Application Alias',
			'Environment',
			'Platform Name',
			'Infrastructure Type',
			'GKE Workload Cluster', 'Deployment', 'Region', 'Tier Level',
			'Requestor', 'Application Viewers'
		]
	},
	{
		title: 'Ownership & Governance',
		labels: [
			'Application Owner Name',
			'Application Owner Email',
			'Platform Owner Name',
			'Platform Owner Email',
			'Portfolio',
			'Application Data Classification',
			'Data Classification'
		]
	},
	{ title: 'Funding Details', labels: ['WBS Code', 'Cost Center'] },
	{
		title: 'Additional Environment',
		labels: ['Source Env Name', 'Additional Env Name']
	}
]

const environmentLabels: Record<string, string> = {
	dev: 'Development',
	staging: 'Staging',
	prod: 'Production'
}

export const getApplicationFieldDisplayValue = ({
	label,
	value
}: Pick<ApplicationField, 'label' | 'value'>) => {
	const rawValue = typeof value === 'object' ? value?.value : value

	return label === 'Environment'
		? environmentLabels[String(rawValue).toLowerCase()] || value?.label || rawValue
		: rawValue
}

export const groupApplicationFields = (fields: ApplicationField[]) => {
	const groupedLabels = new Set(detailGroups.flatMap((group) => group.labels))
	const groups = detailGroups
		.map((group) => ({
			title: group.title,
			fields: group.labels.flatMap((label) =>
				fields.filter((field) => field.label === label)
			)
		}))
		.filter((group) => group.fields.length > 0)
	const otherFields = fields.filter((field) => !groupedLabels.has(field.label))

	return otherFields.length > 0
		? [...groups, { title: 'Other Details', fields: otherFields }]
		: groups
}
